<template>
  <div v-show="!OnLogin" class="breathe tabs is-toggle is-fullwidth" id="navbar">
    <ul>
      <li v-bind:class="{'is-active': HasPath('/user/manage')}" v-if="$store.getters['isGroupManager'] || $store.getters['isAdmin']"><a @click="$router.push({name: 'userAdmin'})">User admin</a></li>
      <li v-bind:class="{'is-active': HasPath('/user/requests')}" v-if="$store.getters['isAdmin']"><a @click="$router.push({name: 'RequestQueue'})">Request queue</a></li>
      <li v-bind:class="{'is-active': HasPath('/user/subscriptions')}" v-if="$store.getters['isAdmin']"><a @click="$router.push({name: 'SubscriptionsAdmin'})">Subscriptions</a></li>
      <li v-bind:class="{'is-active': HasPath('/user/account')}"><a @click="$router.push({ name: 'account'})">My account</a></li>
    </ul>
  </div>
</template>
<script>
  import Role from "@/roles";
  export default {
    data: function () {
      return {

      }
    },
    props: {
      hide: Boolean
    },
    computed: {
      OnLogin() {
        if (this.$route.path == "/login" || this.$route.path == "/" || this.$route.path == "/user/flow")
          return true;
        else
          return false;
      },
    },
    methods: {
      goToCalculator() {
        window.location.href = this.$CCURL;
      },
      HasPath(path) {
        if (this.$route.path.indexOf(path) > -1)
          return true;
        else
          return false;
      }
    },
  }
</script>

<style scoped>
  .tabs.is-toggle li.is-active > a {
    background: lightgrey !important;
    color: black;
    border: solid 1px #dbdbdb;
  }
</style>
